import React, { useEffect } from "react";
import * as theme from "../theme";
import BugReportSimpleString from "./BugReportSimpleString";
import BugReportLargeString from "./BugReportLargeString";
import BugReportYesNo from "./BugReportYesNo";
import { getBrokerInformation } from "../store/broker";
import { useDispatch, useSelector } from "react-redux";

// Adapted from MasterGroupHeaderAndQuestions

const BugReportGroupQuestions = ({
  mainDivRef,
  handleShowScroll,
  formQuestions,
  form,
  openFormId,
  onInput,
}) => {
  const questions = formQuestions[openFormId].questions;
  const minHeightForGroupTab = theme.SCALES.minHeightForGroupTab;
  const brokerInformation = useSelector(getBrokerInformation);
  const languagepreference =
    brokerInformation?.information?.languagepreference || "en";

  useEffect(() => {
    let { scrollHeight, clientHeight } = mainDivRef.current;
    if (scrollHeight > clientHeight) {
      handleShowScroll(true);
    } else {
      handleShowScroll(false);
    }
  });

  return (
    <div style={{ minHeight: minHeightForGroupTab }}>
      <div
        style={{
          minHeight: theme.SCALES.openedQuestionMinHeight,
          display: "flex",
          flexDirection: "column",
          paddingTop: theme.SCALES.paddingTopInEachQuestionList,
          paddingBottom: theme.SCALES.paddingTopInEachQuestionList,
          paddingLeft: theme.SCALES.openedQuestionsLeftPadding,
          paddingRight: theme.SCALES.openedQuestionsRightPadding,
          backgroundColor: theme.COLORS.help_tip,
          borderBottomRightRadius: theme.SCALES.groupTabBorderRadius,
          borderBottomLeftRadius: theme.SCALES.groupTabBorderRadius,
        }}
      >
        {/* Either do a double ternary statement or do something similar to Question.jsx where you import everything and return the right component */}
        {Object.keys(questions).map((question, id) =>
          questions[question].type == "text" ? (
            <BugReportSimpleString
              key={id}
              fieldId={openFormId + " " + id}
              text={questions[question].text[languagepreference]}
              onInput={(e) => onInput(question, e.target.value)}
              value={form[`${question}`]}
            ></BugReportSimpleString>
          ) : questions[question].type == "textarea" ? (
            <BugReportLargeString
              key={id}
              fieldId={openFormId + " " + id}
              minHeight={questions[question].textAreaMinHeight || "12vh"}
              text={questions[question].text[languagepreference]}
              onInput={(e) => onInput(question, e.target.value)}
              value={form[`${question}`]}
            ></BugReportLargeString>
          ) : (
            <BugReportYesNo
              key={id}
              fieldId={openFormId + " " + id}
              text={questions[question].text[languagepreference]}
              onInput={(e) => onInput(question, e.target.value)}
              value={form[`${question}`]}
            ></BugReportYesNo>
          )
        )}
      </div>
    </div>
  );
};

export default BugReportGroupQuestions;
